module.exports = __webpack_public_path__ + "img/zhang1.aa67a162.png";